import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { tableRoutes } from './routes/tables.routes';
import { tableFormRoutes } from './routes/table-forms.routes';
import { currentUserPagesRoutes } from './routes/current-user-pages.routes';
import { SelectClientComponent } from './components/select-client/select-client.component';
import { NavInterfaceComponent } from './components/nav-interface/nav-interface.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { queueRoute } from './routes/queue.routes';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { adminRoutes } from './routes/admin.routes';
import { isPartnerGuard } from './guards/isPartner/is-partner.guard';
import { clientIdGuard } from './guards/client-id/client-id.guard';
import { titanRoutes } from './routes/titan.routes';
import { toolsRoutes } from './routes/tools.routes';
import { DashboardQuicksightComponent } from './components/quicksight-dashboard/dashboard/dashboard.component';
import { QuicksightDashboardComponent } from './components/quicksight-dashboard/quicksight-dashboard.component';
import { fdIdRoutes } from './routes/fdid.routes';
import { SimulatorDashboardComponent } from './components/quicksight-dashboard/simulator/simulator-dashboard/simulator-dashboard.component';
import { PartnerDashboardComponent } from './components/quicksight-dashboard/partner-dashboard/partner-dashboard.component';
import { onboardingRoutes } from './routes/onboarding-automation-services.routes';
import { clientStatusSplashResolver } from './resolvers/client-status-splash.resolver';
import { onboardingWizardRoutes } from './routes/onboarding-wizard.routes';
import { acquireOnboardingWizardRoutes } from './routes/acquire-onboarding-wizard.routes';
import { OnboardingInProcessComponent } from './components/onboarding-wizard/onboarding-in-process/onboarding-in-process.component';
import { ContractAcknowledgmentComponent } from './components/contract-acknowledgment/contract-acknowledgment.component';

const pageRoutes: Routes = [
  {
    path: `login`,
    component: LoginComponent,
    canActivate: [authGuard],
  },
  {
    path: `forgot-password`,
    component: ForgotPasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: `select-client`,
    component: SelectClientComponent,
    canActivate: [authGuard],
    resolve: { clients: clientStatusSplashResolver },

  },
  {
    path: `contract-acknowledgment`,
    component: ContractAcknowledgmentComponent,
    canActivate: [authGuard],
  },
  {
    path: `change-password`,
    component: ChangePasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: `page-not-found`,
    component: PageNotFoundComponent,
    canActivate: [authGuard],
  },
  {
    path: `onboarding-in-process`,
    component: OnboardingInProcessComponent,
    canActivate: [authGuard],
  },
  {
    path: 'global',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/nav-interface-global/nav-interface-global.component').then(
        (m) => m.NavInterfaceGlobalComponent
      ),
    children: [
      {
        path: 'new-client',
        loadComponent: () =>
          import('./components/client/create-new-client/create-new-client.component').then(
            (m) => m.CreateNewClientComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'new-acquirer',
        loadComponent: () =>
          import('./components/client/create-new-acquirer/create-new-acquirer.component').then(
            (m) => m.CreateNewAcquirerComponent
          ),
        canActivate: [authGuard],
      },
    ]
  },
  {
    path: 'client-embed',
    loadComponent: () => import('./components/client-embed/client-embed.component').then(m => m.ClientEmbedComponent)
  }
];

const clientRoute: Routes = [
  {
    path: `client/:clientId`,
    component: NavInterfaceComponent,
    canActivate: [authGuard, clientIdGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    children: [
      ...tableFormRoutes,
      ...tableRoutes,
      ...currentUserPagesRoutes,
      ...queueRoute,
      ...adminRoutes,
      ...titanRoutes,
      ...toolsRoutes,
      ...fdIdRoutes,
      ...onboardingRoutes,
      {
        path: '',
        redirectTo: 'quicksight',
        pathMatch: 'full',
      },
      {
        path: `quicksight`,
        component: QuicksightDashboardComponent,
        pathMatch: 'full',
        canActivate: [authGuard, clientIdGuard, isPartnerGuard],
      },
      {
        path: `quicksight/dashboard`,
        component: DashboardQuicksightComponent,
        canActivate: [authGuard, clientIdGuard, isPartnerGuard],
      },
      {
        path: `quicksight/partner-dashboard`,
        canActivate: [authGuard, isPartnerGuard, clientIdGuard],
        component: PartnerDashboardComponent,
      },
      {
        path: `quicksight/savings-calculator`,
        canActivate: [authGuard, clientIdGuard],
        component: SimulatorDashboardComponent,
      },
    ],
  },
];

const wildcardRoutes: Routes = [
  {
    path: '',
    redirectTo: `login`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: `page-not-found`,
  },
];

export const routes: Routes = [
  ...onboardingWizardRoutes,
  ...acquireOnboardingWizardRoutes,
  ...pageRoutes,
  ...clientRoute,
  ...wildcardRoutes,
];
